import { z } from "zod";

export const invoiceSchema = z.object({
  companyId: z.string().min(1, "Empresa obrigatória"),
  invoiceNumber: z.string().min(1, "Número da fatura obrigatório"),
  nfNumber: z.string().optional(),
  nfDate: z.string().optional(),
  totalAmount: z.coerce
    .number({ error: "Valor inválido" })
    .positive("Valor deve ser positivo"),
  issueDate: z.string().optional(),
  dueDate: z.string().min(1, "Data de vencimento obrigatória"),
  freightIds: z.array(z.string()).optional().default([]),
});

export type InvoiceFormData = z.infer<typeof invoiceSchema>;
